<template>
  <v-main>
    <v-container>
      <div>
        <v-card width="400" class="mx-auto" v-if="checkValid">
          <v-card-title>{{"manage_profile_registration_title" | localize}}</v-card-title>
          <v-divider></v-divider>
          <div class="px-5" @keydown.enter.prevent="activateManager">
            <v-col cols="12">
              <span class="mt-4">
              {{"manage_profile_registration_tex" | localize}}
            </span>
            </v-col>
            <v-col cols="12" md="12" lg="12" xl="12">
              <h3 class="mt-1 mb-1">{{"manage_profile_registration_label_password" | localize}}*</h3>
              <v-text-field
                outlined
                dense
                :label="'manage_profile_registration_label_password' | localize"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                v-model="password.password"
                :hide-details="!passwordError.length"
                :error-messages="passwordError | localize"
                @blur="$v.password.password.$touch()"
              />
              <h3 class="mt-1 mb-1">{{"manage_profile_registration_label_confirm_password" | localize}}*</h3>
              <v-text-field
                outlined
                dense
                :label="'manage_profile_registration_label_confirm_password' | localize"
                :type="showConfirmPassword ? 'text' : 'password'"
                :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showConfirmPassword = !showConfirmPassword"
                v-model="password.password_confirm"
                :hide-details="!passwordConfirmError.length"
                :error-messages="passwordConfirmError | localize"
                @blur="$v.password.password_confirm.$touch()"
              />
              <v-card-actions class="mt-2">
                <v-row justify="end" class="mt-1 mb-1">
                  <v-btn
                     color='#72AFE7'
                    class="font-weight-bold"
                    dark
                    @click="activateManager"
                    >{{"manage_profile_registration_submit_button" | localize}}</v-btn
                  >
                </v-row>
              </v-card-actions>
            </v-col>
          </div>
        </v-card>
        <v-card v-else width="400" class="mx-auto">
          <v-card-title>Oops</v-card-title>
          <v-card-text>{{"wrong_activation_code" | localize}}</v-card-text>
        </v-card>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters } from "vuex";
import AuthService from "@/requests/Auth/AuthService";
import { validationMixin } from "vuelidate";
import { required, sameAs, minLength } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  data: () => ({
    password: [],
    checkValid: false,
    showPassword: false,
    showConfirmPassword: false,
  }),
  validations: {
    password: {
      password: {
        required,
        minLength: minLength(8),
        valid: function (value) {
          const containsUppercase = /[A-Z]/.test(value);
          const containsLowercase = /[a-z]/.test(value);
          const containsNumber = /[0-9]/.test(value);
          const containsSpecial = /[#?!@$%^&*-]/.test(value);
          return (
            containsUppercase &&
            containsLowercase &&
            containsNumber &&
            containsSpecial &&
            minLength
          );
        },
      },
      password_confirm: {
        required,
        sameAsPassword: sameAs("password"),
      },
    },
  },
  mounted() {
    this.validCode();
  },
  methods: {
    async validCode() {
      try {
        let form = new FormData();
        form.append("activation_code", this.$route.params.hesh);
        form.append("lang", this.user.locale);
        form.append("type", process.env.VUE_APP_TYPE);
        let response = await AuthService.validateManager(form);
        if (response.status === 200) {
          this.checkValid = true;
        }
      } catch {
        this.checkValid = false;
      }
    },
    async activateManager() {
      this.$v.password.$touch()
      if (!this.$v.password.$invalid) {
        let form = new FormData();
        form.append("activation_code", this.$route.params.hesh);
        form.append("password", this.password.password);
        form.append("password_confirm", this.password.password_confirm);
        form.append("lang", this.user.locale);
        form.append("type", process.env.VUE_APP_TYPE);
          await AuthService.activateManager(form);
        this.$router.push({ name: "login" });
      }
    },
  },
  watch: {
    user: function (newUser) {
      this.user = newUser;
      this.getCountries();
    },
  },
  computed: {
    ...mapGetters(["user"]),
    passwordError() {
      const errors = [];
      if (!this.$v.password.password.$dirty) {
        return errors;
      }
      if (
        !this.$v.password.password.valid &&
        !this.$v.password.password.minLength
      ) {
        errors.push("password_check_too_weak");
        return errors;
      }
      !this.$v.password.password.required &&
        errors.push("validation_password_required");
      return errors;
    },
    passwordConfirmError() {
      const errors = [];
      if (!this.$v.password.password_confirm.$dirty) {
        return errors;
      }
      if (this.$v.password.password_confirm.required && !this.$v.password.password_confirm.sameAsPassword) {
        errors.push("validation_password_match");
        return errors;
      }
      !this.$v.password.password_confirm.required &&
        errors.push("validation_confirm_password_required");
      return errors;
    },
  },
};
</script>

<style>
</style>